@if (user) {
<aside [ngClass]="menuState">
    <article class="vertical-menu" #menu>
        @for (element of menuElements; track element) {
  
            <ng-container *appFeatureFlag="'menu' + element.route.replaceAll('/', '.')">
            <a [routerLink]="element.route" matRipple routerLinkActive="--active">
                    <mat-icon [ngClass]="{'material-icons-outlined': element.outlined}">{{ element.icon }}</mat-icon>
                    <span>{{ element.name }}</span>
                </a>
            </ng-container>
        
}

            @if (isAdmin) {

                <mat-divider></mat-divider>
                <section class="title">Admin</section>
            
}

            @for (element of adminMenu; track element) {
  

                <ng-container *appFeatureFlag="'menu' + element.route.replaceAll('/', '.')">
                    <a [routerLink]="element.route" matRipple routerLinkActive="--active">
                        @if(element.svgIcon) {
                            <mat-icon [svgIcon]="element.svgIcon"></mat-icon>
                        }
                        @else {
                            <mat-icon [ngClass]="{'material-icons-outlined': element.outlined}">{{ element.icon }}</mat-icon>
                        }
                        <span>{{ element.name }}</span>
                    </a>
                </ng-container>
            
}
    </article>


    <div class="bottom-section">
        <app-user-menu-item></app-user-menu-item>
        <div class="controls">
            <button class="--logout" mat-flat-button color="primary" (click)="signOut()"><mat-icon>logout</mat-icon>Sign out</button>
            <button mat-icon-button [matMenuTriggerFor]="notificationMenu" matTooltip="Notifications"><mat-icon [matBadgeHidden]="notifications === 0" [matBadge]="notifications" matBadgeColor="warn">notifications</mat-icon></button>
        </div>
    </div>
</aside>
}

<mat-menu #notificationMenu="matMenu" yPosition="below" xPosition="before">
    <menu-notifications></menu-notifications>
</mat-menu>